/*                                     */
import { writable, type Writable } from "svelte/store";
import type { Class } from "type-fest";

declare global {
  interface Window {
    __components: {
      extend: typeof extendCustomElement;
    };
  }

  /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
  type HasSlots<$$Slots> = Writable<{ [P in keyof $$Slots]: boolean }>;
}

function updateSlots(
  this: HTMLElement,
  store: HasSlots<unknown>,
  slots: string[],
  mutations: MutationRecord[],
): void {
  if (!mutations.find((m) => m.type === "childList")) {
    /*                               */
    return;
  }

  store.set(
    Object.fromEntries(
      slots.map((s) =>
        s === "default"
          ? [s, this.childNodes.length > 0]
          : [s, !!this.querySelector(`[slot="${s}"]`)],
      ),
    ),
  );
}

function extendCustomElement({
  delegateFocus,
  formAssociated,
  slots = [],
}: {
  formAssociated?: true;
  delegateFocus?: true;
  slots?: string[];
} = {}) {
  return (customElement: Class<HTMLElement & { connectedCallback(...a: unknown[]): void }>) => {
    let result = class extends customElement {
      host: HTMLElement = this;

      /**
 *
 *
 */
      slots: HasSlots<unknown> = writable(Object.fromEntries(slots.map((s) => [s, true])));

      /**
 *
 */
      observer = new MutationObserver(updateSlots.bind(this, this.slots, slots));

      /**
 *
 *
 */
      connectedCallback(...a: unknown[]): void {
        /*                                                          */
        const fakes = slots.map((s) => {
          const fake = document.createElement("span");
          fake.setAttribute("slot", s);
          fake.setAttribute("style", "display:none!");
          this.appendChild(fake);
          return fake;
        });

        /*                    */
        /*                                                                                  */
        super.connectedCallback(...a);

        /*                                                       */
        /*                                  */
        this.observer.observe(this, { childList: true });

        /*                                                        */
        /*                                                                                      */
        requestAnimationFrame(() => {
          fakes.forEach((s) => s.remove());
        });
      }

      disconnectedCallback(): void {
        this.observer.disconnect();
      }
    };

    if (delegateFocus) {
      result = class extends result {
        constructor() {
          super();
          this.attachShadow({ mode: "open", delegatesFocus: true });
        }
      };
    }

    if (formAssociated) {
      result = class extends result {
        static formAssociated = true;

        internals: ElementInternals;

        constructor() {
          super();
          this.internals = this.attachInternals();
        }

        setValidity(flags?: ValidityStateFlags, message?: string, anchor?: HTMLElement): void {
          this.internals.setValidity(flags, message, anchor);
        }

        get willValidate(): boolean {
          return this.internals.willValidate;
        }

        get validity(): ValidityState {
          return this.internals.validity;
        }

        get validationMessage(): string {
          return this.internals.validationMessage;
        }

        get form(): HTMLFormElement | null {
          return this.internals.form;
        }

        formResetCallback(): void {
          /*                                                         */
          /*         */
          this.resetForm?.();
        }
      };
    }

    return result;
  };
}

/*                                                         */
/*         */
/*                                            */
window.__components ??= {};
/*                                            */
window.__components.extend = extendCustomElement;
